import { observable } from 'mobx';

export interface IDrawerStore {
  show: boolean;
};
const drawerStore = observable<IDrawerStore>({
  show: false,
});
export default drawerStore;
